import React, {ChangeEvent} from 'react';
import './checklist-search.scss';

export type ChecklistSearchProps = {
    label: string,
    value: string,
    placeholder?: string,
    onChange: (value: string) => void
}

export function ChecklistSearch({label, value, placeholder, onChange}: ChecklistSearchProps) {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <label className="checklist__search">
            <span>{label}</span>
            <input
                type="search"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
            />
        </label>
    );
}
